import React from 'react';
import CustomToolTip from '../../CustomToolTip';

interface FaultSchedulingTooltipChipProps {
  title: string;
  children: React.ReactNode;
  placement?: 'bottom' | 'top' | 'left' | 'right' | 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end' | 'left-start' | 'left-end' | 'right-start' | 'right-end';
}

export const FaultSchedulingTooltipChip: React.FC<FaultSchedulingTooltipChipProps> = ({ 
  title, 
  children, 
  placement = 'top' 
}) => (
  <CustomToolTip title={title} placement={placement}>
    {children}
  </CustomToolTip>
);
